<template>
  <div>
    <h6>待補充清單</h6>
    <vuetable ref="vuetable"
    :api-url="`${server}/api/drug-storage-not-full/`"
    data-path=""
    pagination-path=""
    :fields="fields"
    :api-mode="true"
    :css="boostrapCss"
    :http-options="httpOptions"
    @vuetable:cell-clicked="onCellClicked">
      <template slot="num-refill" slot-scope="props">
        <span style="color: red">{{ props.rowData.max_stock - props.rowData.stock }}</span>
      </template>
    </vuetable>
    <button class="btn btn-primary" @click="setRefill">設定補藥項目</button>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';


export default {
  name: 'TagPlanning',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        {
          name: '__checkbox',
        },
        // {
        //   name: 'device',
        //   title: '位置',
        //   callback: 'readablePosistion',
        // },
        {
          name: 'device.id',
          title: '位置',
          // callback: 'readablePosistion',
        },
        {
          name: 'medication.generic_name',
          title: '藥物',
        },
        {
          name: 'stock',
          title: '目前存量',
        },
        {
          name: 'max_stock',
          title: '最大存量',
        },
        {
          name: '__slot:num-refill',
          title: '待補數量',
        },
      ],
    };
  },
  components: {
    Vuetable,
  },
  methods: {
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    setRefill() {
      const selected = this.$refs.vuetable.selectedTo;
      if (selected.length !== 0) {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '新增補藥規劃中...',
          confirm: false,
        });
        const promises = [];
        selected.forEach((drugStorageId) => {
          promises.push(this.instance.post('/api/refill-order/', {
            drug_storage_id: drugStorageId,
          }));
        });

        axios.all(promises)
        .then((res) => {
          console.log(res);
          this.$store.commit('SET_MESSAGE', {
            type: 'success',
            context: '新增完成',
            confirm: true,
          });
          this.$refs.vuetable.selectedTo = [];
          this.$refs.vuetable.refresh();
        });
      } else {
        this.$store.commit('SET_MESSAGE', {
          type: 'warn',
          context: '請至少選擇一項藥物',
          confirm: true,
        });
      }
    },
    readablePosistion(val) {
      let pos = `第${val.net.row_id}層`;
      if (val.pos_row !== 0) {
        pos = `${pos} - ${val.pos_row}列 - ${val.relative_col}行`;
      }
      return pos;
    },
  },
  computed: mapState({
    systems: state => state.systems,
    instance: state => state.instance,
  }),
};
</script>




// WEBPACK FOOTER //
// Planning.vue?73af0b94